(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cj-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-cj-gallery]').forEach(gallery => {
  gallery.querySelectorAll('[data-cj-target]').forEach(link => {
    link.addEventListener('click', event => {
      const panel = gallery.querySelector(`[id="${link.dataset.cjTarget}"]`);
      if (!panel) return;
      event.preventDefault();
      gallery.querySelectorAll('[data-cj-panel]').forEach(item => { item.hidden = item !== panel; });
      gallery.querySelectorAll('[data-cj-target]').forEach(item => {
        if (item === link) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
